module.exports = __webpack_public_path__ + "static/BT-mobile-3-2541688e7faea067c959a8bac701990a.jpg";